(() => {
  'use strict';
  const initialiseHeader = () => {
    const header = document.querySelector('[data-cc-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = 'true';
    document.querySelectorAll('[data-cc-open]').forEach(button => {
      button.addEventListener('click', () => {
        const dialog = document.getElementById(`cc-${button.dataset.ccOpen}-dialog`);
        if (!dialog) return;
        dialog.showModal();
        if (button.dataset.ccOpen === 'search') dialog.querySelector('input[type=search]')?.focus();
      });
    });
    document.querySelectorAll('.cc-dialog').forEach(dialog => {
      dialog.querySelector('[data-cc-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target === dialog) {
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }
        if (event.target.closest('a')) dialog.close();
      });
    });
  };
  class CinemaSlideshow {
    constructor(root) {
      this.root = root;
      this.slides = [...root.querySelectorAll('.cc-slide')];
      this.dots = [...root.querySelectorAll('[data-slide-to]')];
      this.pause = root.querySelector('[data-slide-pause]');
      this.status = root.querySelector('[data-slide-status]');
      this.index = 0;
      this.timer = null;
      this.visible = true;
      this.hovered = false;
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.saveData = Boolean(navigator.connection?.saveData);
      this.paused = root.dataset.autoplay !== 'true' || this.motion.matches || this.saveData;
      this.interval = Math.max(5000, Number(root.dataset.interval) || 7000);
      const on = (target, event, fn) => target?.addEventListener(event, fn, { signal:this.abort.signal });
      this.dots.forEach((dot,i) => on(dot,'click',() => this.go(i,true)));
      on(root.querySelector('[data-slide-prev]'),'click',() => this.go(this.index-1,true));
      on(root.querySelector('[data-slide-next]'),'click',() => this.go(this.index+1,true));
      on(this.pause,'pointerdown',() => { this.pauseBeforePointer = this.paused; });
      on(this.pause,'click',() => { this.paused = typeof this.pauseBeforePointer === 'boolean' ? !this.pauseBeforePointer : !this.paused; this.pauseBeforePointer = undefined; this.sync(); });
      on(root,'mouseenter',() => {if(matchMedia('(hover: hover)').matches){this.hovered=true;this.sync();}});
      on(root,'mouseleave',() => {this.hovered=false;this.sync();});
      // Once keyboard focus enters, automatic rotation waits for an explicit restart.
      on(root,'focusin',() => { this.paused=true;this.sync(); });
      on(root,'keydown',event => {
        if (event.key==='ArrowRight') { event.preventDefault();this.go(this.index+1,true); }
        if (event.key==='ArrowLeft') { event.preventDefault();this.go(this.index-1,true); }
      });
      let touchStart = null;
      on(root,'touchstart',event => {if(event.touches.length===1)touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};});
      on(root,'touchend',event => {
        if(!touchStart)return;const touch=event.changedTouches[0];const dx=touch.clientX-touchStart.x;const dy=touch.clientY-touchStart.y;touchStart=null;
        if(Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)*1.5)this.go(this.index+(dx<0?1:-1),true);
      });
      on(document,'visibilitychange',() => this.sync());
      on(this.motion,'change',() => {if(this.motion.matches)this.paused=true;this.sync();});
      on(this.mobile,'change',() => this.sync());
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.15});this.observer.observe(root);
      on(document,'shopify:block:select',event=>{const i=this.slides.findIndex(slide=>slide.dataset.blockId===event.detail?.blockId);if(i>=0)this.go(i,true);});
      this.render(false);
    }
    go(index,manual=false){
      if(!this.slides.length)return;
      if(manual)this.paused=true;
      this.index=(index+this.slides.length)%this.slides.length;
      this.render(manual);
    }
    render(announce){
      this.slides.forEach((slide,i)=>{const active=i===this.index;slide.classList.toggle('is-active',active);slide.inert=!active;if(active)slide.removeAttribute('aria-hidden');else slide.setAttribute('aria-hidden','true');});
      this.dots.forEach((dot,i)=>{if(i===this.index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});
      const count=this.root.querySelector('[data-slide-count]');if(count)count.textContent=`${String(this.index+1).padStart(2,'0')} / ${String(this.slides.length).padStart(2,'0')}`;
      if(announce && this.status)this.status.textContent=this.slides[this.index].getAttribute('aria-label');
      this.sync();
    }
    sync(){
      clearTimeout(this.timer);
      const active=!document.hidden && this.visible && !this.hovered;
      if(this.pause){this.pause.textContent=this.paused?'▶':'Ⅱ';this.pause.setAttribute('aria-label',this.paused?'Play slideshow':'Pause slideshow');}
      this.slides.forEach((slide,i)=>{
        const video=slide.querySelector('[data-hero-video]');if(!video)return;
        const allowed=i===this.index && active && !this.paused && !this.motion.matches && !this.saveData && (!this.mobile.matches || video.dataset.mobileVideo==='true');
        if(!allowed){video.pause();video.classList.remove('is-playing');return;}
        if(!video.dataset.loaded){video.querySelectorAll('source[data-src]').forEach(source=>{source.src=source.dataset.src;});video.load();video.dataset.loaded='true';}
        video.play()?.then(()=>{if(i===this.index && !this.paused && this.visible && !document.hidden)video.classList.add('is-playing');else video.pause();}).catch(()=>video.classList.remove('is-playing'));
      });
      if(active && !this.paused && this.slides.length>1)this.timer=setTimeout(()=>this.go(this.index+1),this.interval);
    }
    destroy(){clearTimeout(this.timer);this.observer.disconnect();this.abort.abort();this.slides.forEach(s=>s.querySelector('video')?.pause());}
  }
  const mount = scope => {
    initialiseHeader();
    scope.querySelectorAll('[data-cc-slideshow]').forEach(root=>{if(!root.ccSlideshow)root.ccSlideshow=new CinemaSlideshow(root);});
  };
  mount(document);
  document.addEventListener('shopify:section:load',event=>mount(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-cc-slideshow]').forEach(root=>root.ccSlideshow?.destroy()));
  const reveal = () => {if(!location.hash)return;const target=document.getElementById(location.hash.slice(1));if(target?.tagName==='DETAILS')target.open=true;};
  document.addEventListener('click',event=>{const link=event.target.closest('a[href*="#"]');if(!link)return;const url=new URL(link.href);if(url.pathname!==location.pathname)return;const target=document.getElementById(url.hash.slice(1));if(target?.tagName==='DETAILS')target.open=true;});
  window.addEventListener('hashchange',reveal);reveal();
})();
